import React, {useRef, useState, Fragment, useEffect, ComponentProps} from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import b_ from 'b_';

import {Button, Popup, Tooltip, Textinput, Icon} from 'client/common/components/lego';

import I18N from 'assets/i18n/brandlift-project';

import './share-button2.css';

const i18n = I18N.common.shareButton2;
const b = b_.with('share-button2');

interface SharePopupProps {
    link: string;
    onClose: () => void;
}

function SharePopupContent({link, onClose}: SharePopupProps) {
    const [isCopyTooltipVisible, setIsCopyTooltipVisible] = useState(false);
    const inputControl = useRef<HTMLInputElement>(null);
    const copyButton = useRef(null);

    const onCopy = () => {
        setIsCopyTooltipVisible(true);
        setTimeout(() => setIsCopyTooltipVisible(false), 1000);
    };

    useEffect(() => {
        // eslint-disable-next-line no-unused-expressions
        inputControl.current?.select();
    }, []);

    return (
        <>
            <p className={b('popup-title')}>{i18n.popupTitle}</p>
            <Textinput
                className={b('text-input')}
                size='m'
                view='dl'
                controlRef={inputControl}
                defaultValue={link}
            />
            <CopyToClipboard text={link}>
                <Button
                    innerRef={copyButton}
                    className={b('button')}
                    view='dl-action'
                    size='m'
                    onClick={onCopy}
                >
                    {i18n.copyToBuffer}
                </Button>
            </CopyToClipboard>
            <Button className={b('button')} view='dl-default' size='m' onClick={onClose}>
                {i18n.close}
            </Button>
            <Tooltip
                size='s'
                view='default'
                anchor={copyButton}
                visible={isCopyTooltipVisible}
                zIndex={1010}
            >
                {i18n.copied}
            </Tooltip>
        </>
    );
}

type ButtonProps = ComponentProps<typeof Button>;

interface ShareButtonProps extends ButtonProps {
    link: string;
}

export default function ShareButton2(props: ShareButtonProps) {
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const shareButton = useRef(null);

    const {link, className = '', width} = props;

    return (
        <Fragment>
            <Button
                className={`${b()} ${className}`}
                innerRef={shareButton}
                view='dl-default'
                size='s'
                onClick={() => setIsPopupVisible(true)}
                width={width}
                iconLeft={(cls: string) => {
                    return <Icon className={cls} type='share' />;
                }}
            >
                {i18n.shareLink}
            </Button>
            <Popup
                anchor={shareButton}
                className={b('popup')}
                keepMounted={false}
                target='anchor'
                view='default'
                visible={isPopupVisible}
                // Чтобы перебить модал
                zIndex={1010}
            >
                <SharePopupContent link={link} onClose={() => setIsPopupVisible(false)} />
            </Popup>
        </Fragment>
    );
}
